/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ─── Shipping Protection ────────────────────────────────────────────────────
  //
  // Handles the shipping-protection toggle in the cart drawer and cart page.
  // The toggle UI is rendered by snippets/shipping-protection.liquid inside
  // [data-cart-price-holder], which the theme re-renders after every cart
  // update via its getCart() → build() cycle.
  //
  // We use event delegation on `document` so the listener survives DOM
  // replacements caused by cart refreshes.
  // ────────────────────────────────────────────────────────────────────────────

  /**
   * Add the shipping-protection variant to the cart, then refresh.
   * Prevents duplicates by checking the cart state before adding.
   */
  function addShippingProtection(variantId, checkboxEl) {
    checkboxEl.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function(res) {
        if (!res.ok) throw new Error('add failed: ' + res.status);
        return res.json();
      })
      .then(function() {
        refreshCart();
      })
      .catch(function(err) {
        console.error('[ShippingProtection] add error:', err);
        // Revert toggle on failure
        checkboxEl.checked = false;
        checkboxEl.disabled = false;
      });
  }

  /**
   * Remove the shipping-protection variant from the cart, then refresh.
   * Uses /cart/change.js with quantity:0 targeting the correct 1-based line index.
   */
  function removeShippingProtection(variantId, checkboxEl) {
    checkboxEl.disabled = true;

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var variantIdInt = parseInt(variantId, 10);
        // Find the 1-based line index of the protection item
        var lineIndex = -1;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === variantIdInt) {
            lineIndex = i + 1;
            break;
          }
        }

        if (lineIndex === -1) {
          // Already gone — just refresh to sync state
          refreshCart();
          return;
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ line: lineIndex, quantity: 0 }),
        });
      })
      .then(function() {
        refreshCart();
      })
      .catch(function(err) {
        console.error('[ShippingProtection] remove error:', err);
        // Revert toggle on failure
        checkboxEl.checked = true;
        checkboxEl.disabled = false;
      });
  }

  /**
   * Trigger the theme's built-in cart refresh.
   * window.cart is the CartDrawer instance set by theme.dev.js:
   *   window.cart = new CartDrawer();
   * Its getCart() fetches /cart?section_id=api-cart-items and calls build(),
   * which re-renders [data-cart-price-holder], [data-items-holder], and
   * [data-upsell-products], then dispatches 'theme:cart:change'.
   */
  function refreshCart() {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
    }
  }

  var SP_OPT_OUT_KEY = 'sp_opted_out';

  /**
   * Auto-add shipping protection if the widget is present, unchecked,
   * the merchant has enabled default-on, and the customer hasn't opted out.
   */
  function autoAddIfDefault() {
    var wrapper = document.querySelector('[data-shipping-protection]');
    if (!wrapper) return;

    if (wrapper.getAttribute('data-default-on') !== 'true') return;

    var checkbox = wrapper.querySelector('.shipping-protection__checkbox');
    if (!checkbox || checkbox.checked || checkbox.disabled) return;

    if (sessionStorage.getItem(SP_OPT_OUT_KEY)) return;

    var variantId = wrapper.getAttribute('data-variant-id');
    if (!variantId) return;

    // Optimistically check so the UI doesn't flicker
    checkbox.checked = true;
    addShippingProtection(variantId, checkbox);
  }

  /**
   * Delegated change handler — fires for any checkbox change on the page,
   * filtered to only act on shipping-protection toggles.
   */
  function onToggleChange(event) {
    var el = event.target;
    if (!el.classList.contains('shipping-protection__checkbox')) return;

    var wrapper = el.closest('[data-shipping-protection]');
    if (!wrapper) return;

    var variantId = wrapper.getAttribute('data-variant-id');
    if (!variantId) return;

    if (el.checked) {
      sessionStorage.removeItem(SP_OPT_OUT_KEY);
      addShippingProtection(variantId, el);
    } else {
      sessionStorage.setItem(SP_OPT_OUT_KEY, '1');
      removeShippingProtection(variantId, el);
    }
  }

  // Attach once; delegation handles dynamically re-rendered toggles
  document.addEventListener('change', onToggleChange);

  // Auto-add on initial load and after every cart re-render
  document.addEventListener('DOMContentLoaded', autoAddIfDefault);
  document.addEventListener('theme:cart:change', autoAddIfDefault);

  // ─── Purchase without protection (PDP express path) ─────────────────────────
  //
  // Order protection is the Redo app. Its drawer CTA offers "Checkout+"
  // (writes cart attribute redo_opted_in_from_cart="true" and adds a
  // vendor "re:do" line priced off the cart) or "continue without"
  // (writes "false", adds nothing); the checkout toggle seeds from that
  // attribute. The PDP wallet button bypasses the drawer, so this link
  // is the same decline for the PDP path, speaking Redo's protocol
  // (observed live Oct 17, 2026).

  var REDO_VENDOR = 're:do';

  function stripRedoLines(cart) {
    // Line keys, not variant ids: unique per line, so a same-variant main
    // item can never be swept along with the coverage line.
    var redoLineKeys = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].vendor === REDO_VENDOR) redoLineKeys.push(cart.items[i].key);
    }
    return redoLineKeys.reduce(function (chain, key) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        }).then(function (res) {
          if (!res.ok) throw new Error('protection line removal failed: ' + res.status);
        });
      });
    }, Promise.resolve());
  }

  function onNoProtectionClick(event) {
    var link = event.target.closest('[data-june-no-protection]');
    if (!link || link.classList.contains('is-busy')) return;

    var form = link.closest('form');
    if (!form) return;

    var atcButton = form.querySelector('[data-add-to-cart]');
    if (atcButton && atcButton.disabled) return; // sold out

    var idInput = form.elements.namedItem('id');
    var variantId = idInput ? parseInt(idInput.value, 10) : NaN;
    if (!variantId) return;

    var qtyInput = form.elements.namedItem('quantity');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    event.preventDefault();
    link.classList.add('is-busy');

    // Disarms the legacy theme auto-add should its product ever resolve
    // again — that code still reads this key on theme:cart:change.
    sessionStorage.setItem(SP_OPT_OUT_KEY, '1');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed: ' + res.status);
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(stripRedoLines)
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes: { redo_opted_in_from_cart: 'false' } }),
        });
      })
      .then(function (res) {
        // Without the attribute the checkout would re-offer protection
        // against the shopper's click, so never navigate on failure.
        if (!res.ok) throw new Error('attribute update failed: ' + res.status);
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('[NoProtection] purchase error:', err);
        link.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', onNoProtectionClick);

  // bfcache restores the PDP with is-busy still set after Back from checkout
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var busyLink = document.querySelector('[data-june-no-protection].is-busy');
    if (busyLink) busyLink.classList.remove('is-busy');
  });

  // ─── End Shipping Protection ─────────────────────────────────────────────────


  // ─── Order Policy Gate ───────────────────────────────────────────────────────
  //
  // Stops checkout when the merchant has enabled "Require checkbox to checkout"
  // and the policy box is unchecked. The checkout buttons stay looking normal
  // — when the customer clicks one, we intercept the event and reveal an
  // inline red error message next to the policy toggle. Once they tick the
  // box, the error hides and the next click goes through.
  //
  // The checkbox renders server-side as `checked` when "Default to ON" is on.
  // If the customer explicitly unchecks it, we remember that for the session
  // so cart re-renders don't silently re-tick the box behind them.
  // ────────────────────────────────────────────────────────────────────────────

  var OP_OPT_OUT_KEY = 'op_opted_out';

  function applyOrderPolicyOptOut() {
    var wrapper = document.querySelector('[data-order-policy]');
    if (!wrapper) return;
    if (wrapper.getAttribute('data-default-on') !== 'true') return;

    var checkbox = wrapper.querySelector('.order-policy__checkbox');
    if (!checkbox) return;

    if (sessionStorage.getItem(OP_OPT_OUT_KEY)) {
      checkbox.checked = false;
    }
  }

  function isPolicyBlocking() {
    var wrapper = document.querySelector('[data-order-policy]');
    if (!wrapper) return false;
    if (wrapper.getAttribute('data-required') !== 'true') return false;

    var checkbox = wrapper.querySelector('.order-policy__checkbox');
    return !checkbox || !checkbox.checked;
  }

  function showOrderPolicyError() {
    document.querySelectorAll('[data-order-policy]').forEach(function (wrapper) {
      wrapper.classList.add('is-missing');
      var error = wrapper.querySelector('[data-order-policy-error]');
      if (error) error.hidden = false;
    });
  }

  function hideOrderPolicyError() {
    document.querySelectorAll('[data-order-policy]').forEach(function (wrapper) {
      wrapper.classList.remove('is-missing');
      var error = wrapper.querySelector('[data-order-policy-error]');
      if (error) error.hidden = true;
    });
  }

  // Drop a transparent overlay on top of the additional-checkout-buttons
  // container while the gate is locked. Clicks inside Shop Pay / PayPal /
  // Apple Pay / Google Pay iframes don't bubble out, so we need a real
  // layer above them to intercept the event.
  function syncAdditionalCheckoutOverlay() {
    var blocked = isPolicyBlocking();
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.classList.toggle('is-policy-blocked', blocked);
    });
  }

  function onPolicyCheckboxChange(event) {
    var el = event.target;
    if (!el.classList.contains('order-policy__checkbox')) return;

    if (el.checked) {
      sessionStorage.removeItem(OP_OPT_OUT_KEY);
      hideOrderPolicyError();
    } else {
      sessionStorage.setItem(OP_OPT_OUT_KEY, '1');
    }
    syncAdditionalCheckoutOverlay();
  }

  // Intercept clicks on any checkout-bound element while the gate is locked.
  // Surface the inline error and scroll the customer to it.
  function onCheckoutClick(event) {
    var inMain       = event.target.closest('button[name="checkout"], input[name="checkout"]');
    var inAdditional = event.target.closest('.additional-checkout-buttons');
    if (!inMain && !inAdditional) return;

    if (!isPolicyBlocking()) return;

    event.preventDefault();
    event.stopPropagation();

    showOrderPolicyError();

    var wrapper = document.querySelector('[data-order-policy]');
    if (wrapper) wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function initOrderPolicy() {
    applyOrderPolicyOptOut();
    syncAdditionalCheckoutOverlay();
  }

  document.addEventListener('change', onPolicyCheckboxChange);
  document.addEventListener('click', onCheckoutClick, true);
  document.addEventListener('DOMContentLoaded', initOrderPolicy);
  document.addEventListener('theme:cart:change', initOrderPolicy);

  // ─── End Order Policy Gate ───────────────────────────────────────────────────



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
